var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.433 4.47a.96.96 0 00-1.082 1.586C18.69 7.65 20.2 10.549 20.2 13.44c0 4.764-3.877 8.64-8.64 8.64-4.765 0-8.64-3.876-8.64-8.64 0-4.4 3.31-8.036 7.568-8.567L9.034 6.727a.96.96 0 001.511 1.185l2.73-3.48a.961.961 0 00-.18-1.36L9.256.192a.96.96 0 10-1.151 1.536l1.738 1.304C4.835 3.857 1 8.203 1 13.44 1 19.262 5.737 24 11.56 24c5.822 0 10.56-4.738 10.56-10.56 0-3.509-1.84-7.03-4.687-8.97",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconRefresh;